<template>
  <div class="news-carousel">
    <div class="news-carousel__title">{{ $tNews('Gallery') }}</div>
    <div ref="news-carousel" class="news-carousel__wrap">
      <div class="news-carousel__list">
        <div v-for="(item, index) in slides"
             :key="item + index"
             @click.prevent="onClickSlide(index)"
             class="news-carousel__item">
          <v-lazy-image :src="item"
                        :alt="createAltMixin('Gallery - ' + title, index + 1)"
                        :title="createTitleMixin('Gallery - ' + title, index + 1)"
                        class="news-carousel__item-img-wrap"
                        @load="update"
                        use-picture>
            <source v-if="slidesWebp[index]"
                    :srcset="slidesWebp[index]"
                    type="image/webp">
          </v-lazy-image>
        </div>
      </div>

      <button ref="prev" class="news-carousel__nav  _prev  base-btn  base-btn--grey-blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <button ref="next" class="news-carousel__nav  _next  base-btn  base-btn--grey-blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <div ref="pagination" class="news-carousel__pagination"></div>
    </div>
    <CoolLightBox v-if="slides.length"
                  :items="slides"
                  :index="modalGalleryIndex"
                  @close="modalGalleryIndex = null"/>
  </div>
</template>

<script>
  import Swiper from "swiper";

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ "../components/CoolLightBox");

  export default {
    name: "NewsCarousel",
    components: {
      CoolLightBox
    },
    props: {
      slides: {
        type: Array,
        required: true
      },
      slidesWebp: {
        type: Array,
        required: true
      },
      title: String
    },
    data() {
      return {
        swiper: null,
        modalGalleryIndex: null
      }
    },
    computed: {},
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['news-carousel'], {
          wrapperClass: 'news-carousel__list',
          slideClass: 'news-carousel__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          navigation: {
            prevEl: this.$refs['prev'],
            nextEl: this.$refs['next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },
          pagination: {
            el: this.$refs['pagination'],
            type: 'bullets',
            bulletClass: 'news-carousel__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden',
            clickable: true
          },
        })
      },
      update() {
        this.swiper.update()
      },
      onClickSlide(index) {
        return this.modalGalleryIndex = index
      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    },
    watch: {
      slides() {

      }
    }
  }
</script>

<style>

</style>
